import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { SLIM_ROUTES } from '@/shared/routes'

export const PublicRoute = () => {
  const { isAuthenticated, isInitializing } = useAuth()
  const location = useLocation()

  if (isInitializing) return null

  if (isAuthenticated) {
    return (
      <Navigate
        to={SLIM_ROUTES.HOME}
        replace
        state={{ from: location.pathname }}
      />
    )
  }
  return <Outlet />
}
